import React from 'react';
import Text from 'components/Text/Text';
import { Checkbox, Form } from 'antd';
import style from './UseTLSCertificate.module.scss';

interface IProps {
	toggleUseTLSCertificate: () => void;
	useTlsCertificate: boolean;
}

const UseTLSCertificate: React.FC<IProps> = ({ toggleUseTLSCertificate, useTlsCertificate }) => {
	return (
		<Form.Item className={style.container} name="useTlsCertificate">
			<Checkbox checked={useTlsCertificate} onChange={toggleUseTLSCertificate}>
				<Text translationNameSpace="form" translationKey="useTLSCertificateLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(UseTLSCertificate);
